import { render } from "./CouponQr.vue?vue&type=template&id=f1265bf4&scoped=true"
import script from "./CouponQr.vue?vue&type=script&lang=js"
export * from "./CouponQr.vue?vue&type=script&lang=js"

import "./CouponQr.vue?vue&type=style&index=0&id=f1265bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1265bf4"]])

export default __exports__